import React, { useState } from 'react'
import { useToast } from '~/lib/ui/toast'
import { useDropzone } from 'react-dropzone'
import { cn } from '~/lib/utils'
import { useTranslation } from '~/hooks/useTranslation'
import { useBenefits } from '../BenefitsProvider'

const FileAttachmentDropzone = ({ className, translationScope, fieldName }) => {
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { serviceRequestForm } = useBenefits()
  const { getValues, setValue, register } = serviceRequestForm

  // Translation fields
  //
  // <translationScope>:
  //   file_upload:
  //     <fieldName>:
  //       label:
  //       help_text:
  //       file_attached_text:
  //       could_not_attach_file:
  //       required_file_formats:
  const { t } = useTranslation(`${translationScope}.file_upload.${fieldName}`)
  const { toast } = useToast()

  const rejectionMessage = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors
      .map((e) => ` • ${t(e.code.replaceAll('-', '_'))}`)
      .join('\n')
    if (type) {
      toast({
        description,
        title: t('could_not_attach_file'),
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const updateFileField = (file) => {
    setValue(fieldName, file)
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted: (incomingFiles) => updateFileField(incomingFiles[0]),
    onDropRejected: (incomingFiles) => rejectionMessage(incomingFiles),
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxFiles: 1,
    maxSize: 15_000_000, // 15MB
  })

  const currentFiles = getValues(fieldName)
  const currentFile = currentFiles?.length == undefined ? currentFiles : null
  const displayMessage = currentFile ? currentFile.name : t('help_text')

  return (
    <div>
      <label>{t('label')}</label>
      <div {...getRootProps()}>
        <input
          type="file"
          name={fieldName}
          style={{ opacity: 0 }}
          {...register(fieldName)}
        />
        <input {...getInputProps()} className="tw-hidden" />
        <div
          className={cn(
            'min-h-[20rem] cursor-pointer content-center justify-items-center border border-dashed p-4 text-center',
            isDraggingOver ? 'border-2 border-primary bg-lily-blue' : '',
            className,
          )}
        >
          <div>
            {currentFile && <p>{t('file_attached_text')}</p>}
            <p>{displayMessage}</p>
            <em>{t('file_invalid_type')}</em>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FileAttachmentDropzone
